import React, { useState, useEffect } from 'react';
import SectionHeader from '../shared/SectionHeader';
import { fetchTestimonials } from '../../Services/ApiCallsServices/TestimonialsApi';

const TestimonialsSection = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const loadTestimonials = async () => {
            try {
                const data = await fetchTestimonials();
                if (isMounted) setTestimonials(data);
            } catch (error) {
                console.error("Error fetching testimonials:", error);
                if (isMounted) setTestimonials([]);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadTestimonials();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <section id="Testimonials" className="py-20 bg-gray-50">
            <div className="container mx-auto px-6">
                <SectionHeader
                    title="What Our Clients"
                    highlight="Say"
                    say
                    subtitle="Don't just take our word for it - hear from our satisfied customers."
                />

                {loading ? (
                    <p className="text-center text-gray-500">Loading testimonials...</p>
                ) : testimonials.length === 0 ? (
                    <p className="text-center text-gray-500">No testimonials available at the moment.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="testimonial-card rounded-xl p-8 relative shadow-md bg-white">
                                <div className="flex items-center mb-6">
                                    <div>
                                        <h4 className="font-bold text-lg">{testimonial.name}</h4>
                                        <p className="text-yellow-500">{testimonial.occupation}</p>
                                    </div>
                                </div>
                                <p className="text-gray-600 italic">"{testimonial.testimonial}"</p>
                                <div className="flex mt-4">
                                    {[...Array(5)].map((_, i) => (
                                        <i
                                            key={i}
                                            className={`fas fa-star ${i < testimonial.rating ? 'text-yellow-500' : 'text-gray-300'}`}
                                        ></i>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default TestimonialsSection;
